{
  "page": "Page {{pageNumber}} of {{total}}",
  "rowsPerPage": "Rows per page",
  "selectedRow": "{{selected}} of {{total}} row(s) selected",
  "refresh": "Refresh",
  "sortBy": "Sort By:",
  "viewColumns": "View",
  "export": "Export",
  "exportPdf": "Export PDF",
  "exportExcel": "Export Excel",
  "newest": "Newest",
  "oldest": "Oldest"
}
